import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-header-banner',
    templateUrl: './header-banner.component.html',
    styleUrls: ['./header-banner.component.scss'],
    standalone: false
})
export class HeaderBannerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
